import type { Offset } from '@/utils/offset'

const DISTANCE_STEP = 20
const MAX_DISTANCE = 6
const MIN_DISTANCE = 3

const ANGLE_STEPS_COUNT = 12
const ANGLE_STEP = (2 * Math.PI) / ANGLE_STEPS_COUNT

const getRandomInt = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min

export const randomShift = (offset: Offset): Offset => {
  const distance = getRandomInt(MIN_DISTANCE, MAX_DISTANCE) * DISTANCE_STEP

  const angle = getRandomInt(0, ANGLE_STEPS_COUNT - 1) * ANGLE_STEP

  const x = offset.x + Math.floor(Math.cos(angle) * distance)
  const y = offset.y + Math.floor(Math.sin(angle) * distance)

  return { x, y }
}
